import {
  IN_STOCK,
  LOW_IN_STOCK,
  OUT_OF_STOCK,
  COLOUR_OUT_OF_STOCK,
  SIZE_OUT_OF_STOCK,
  COLOUR_OR_SIZE_OUT_OF_STOCK,
  RESTOCKING_SOON
} from "./stockConstants";

const getStockStatusForItemInStockOrLowInStock = ({ isVariantLowInStock }) =>
  isVariantLowInStock ? LOW_IN_STOCK : IN_STOCK;

const getStockStatusForVariantOutOfStockButOthersInStock = ({
  isOneColour,
  isSingleSize
}) => {
  if (isOneColour) return SIZE_OUT_OF_STOCK;
  if (isSingleSize) return COLOUR_OUT_OF_STOCK;

  return COLOUR_OR_SIZE_OUT_OF_STOCK;
};

const getStockStatusForProductInStockOrRestockingSoon = ({
  isProductInStock,
  isRestockingSoon
}) => {
  if (isProductInStock) {
    return null;
  }

  if (isRestockingSoon) {
    return RESTOCKING_SOON;
  }

  return OUT_OF_STOCK;
};

const getStockStatus = ({
  isProductInStock,
  isVariantLowInStock,
  isVariantInStock,
  isOneColour,
  isOneSize,
  isNoSize,
  isRestockingSoon,
  variantId
}) => {
  const productLevelStockStatus =
    getStockStatusForProductInStockOrRestockingSoon({
      isProductInStock,
      isRestockingSoon
    });

  if (productLevelStockStatus !== null) {
    return productLevelStockStatus;
  }

  if (variantId !== null) {
    if (isVariantInStock) {
      return getStockStatusForItemInStockOrLowInStock({
        isVariantLowInStock
      });
    }

    return getStockStatusForVariantOutOfStockButOthersInStock({
      isOneColour,
      isSingleSize: isOneSize || isNoSize
    });
  }

  return IN_STOCK;
};

export default getStockStatus;
